import { useAuth } from '../context/AuthContext';

export default function TrialExpirado() {
  const { logout } = useAuth();
  return (
    <div style={{minHeight:'100vh',background:'#16181d',display:'flex',alignItems:'center',justifyContent:'center',padding:'24px'}}>
      <div style={{background:'#1e2128',border:'1px solid #2e3140',borderRadius:'8px',padding:'48px 40px',maxWidth:'480px',width:'100%',textAlign:'center'}}>
        <div style={{fontSize:'48px',marginBottom:'16px'}}>⏰</div>
        <h1 style={{fontFamily:'sans-serif',color:'#eef0f6',fontSize:'28px',marginBottom:'12px'}}>Tu prueba gratuita ha terminado</h1>
        <p style={{color:'#7a8099',fontSize:'15px',lineHeight:'1.7',marginBottom:'32px'}}>Han pasado los 7 días de prueba. Contacta con nosotros y te activamos el plan que mejor se adapte a tu empresa.</p>
        <a href="mailto:hola@tempogestion.es?subject=Quiero activar mi cuenta" style={{display:'block',background:'#4f8ef7',color:'#fff',padding:'14px 24px',borderRadius:'4px',textDecoration:'none',fontWeight:'600',fontSize:'15px',marginBottom:'12px'}}>Contactar para activar cuenta</a>
        <button onClick={logout} style={{background:'transparent',border:'1px solid #2e3140',color:'#7a8099',padding:'10px 24px',borderRadius:'4px',cursor:'pointer',fontSize:'14px',width:'100%'}}>Cerrar sesión</button>
      </div>
    </div>
  );
}
